var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGapXs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 180,
    height: 82,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 180,
    height: 82,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 49,
    width: 38,
    height: 31,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 49,
    width: 38,
    height: 31,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 49,
    width: 38,
    height: 31,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 49,
    width: 38,
    height: 31,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 49,
    width: 38,
    height: 31,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 49,
    width: 38,
    height: 31,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 49,
    width: 39,
    height: 31,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 49,
    width: 39,
    height: 31,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 16,
    width: 38,
    height: 30,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 16,
    width: 38,
    height: 30,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 16,
    width: 38,
    height: 30,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 16,
    width: 38,
    height: 30,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 16,
    width: 38,
    height: 30,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 16,
    width: 38,
    height: 30,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 39,
    height: 30,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 39,
    height: 30,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGapXs);
export default __webpack_public_path__ + "static/media/gap_xs.34179de6788a35bf7d37077b16c80ac8.svg";
export { ForwardRef as ReactComponent };